import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\src\\components\\nav\\shared\\navLink\\NavFooterLink.tsx");
